<template>
  <div id="wrap">
    <app-header />
    <header-step
      step="1"
      alt="ステップ１：連絡先（通知）メールアドレス・学校名入力"
    />

    <main>
      <h2>
        <span
          >連絡先（通知）メールアドレス・<br
            class="sp"
          />学校名をご入力ください</span
        >
      </h2>
      <p class="mb05 lead">
        ICタグを持っておらず、ICタグ貸出（無料）のお申込みをご希望の方はご入力ください。<br />ご入力いただいたメールアドレスに、無料ICタグお申込み用のURLをお送りいたします。
      </p>
      <p class="mb2 sml lead">
        ※メールアドレスはツイタもんからの通知メールアドレスとして利用されます。
      </p>

  <div class="link">
		<ul>
			<li><a href="https://www.tsuitamon.jp/" target="_blank">サービス紹介</a></li>
			<li><a href="https://www.tsuitamon-py.net/paidplan_apply/" target="_blank">すでにICタグを持っており有料会員への入会をご希望の方は、<br class="pc">有料会員入会フォームへ</a></li>
		</ul>
	</div>

      <form id="f-inp" ref="fInp" autocomplete="off">
        <div class="section top">
          <!-- 学校名 -->
          <div>
            <h3>学校名</h3>
            <p class="lead1">
              お子さまが通われている（今年入学される）<br
                class="sp"
              />学校名を検索し、候補から選択してください。
            </p>
            <ul>
              <li>
                <div>
                  <input type="text" name="school" v-model="kw" />
                  <button
                    type="button"
                    id="school_btn"
                    v-bind:disabled="this.isKwEmpty"
                    @click="searchSchool"
                  >
                    <fa-icon :icon="['fas', 'search']"></fa-icon>検索
                  </button>
                </div>
                <span class="lead4">
                  学校名の一部（漢字・ふりがなどちらでも可）を入力して、検索すると学校名選択欄に候補が表示されます。対象学校が表示されない場合は学校名の一部を変更して検索してみてください。
                </span>
              </li>
              <li class="school_result">
                <p>学校名</p>
                <div>
                  <select
                    name="school_id"
                    id="school_select"
                    ref="schoolSel"
                    v-model="schoolId"
                    @change="updateInputError"
                  >
                    <option value="">
                      <span>{{ schoolList.length }}</span
                      >件の候補があります。
                    </option>
                    <option
                      v-for="one in schoolList"
                      :key="one.school_id"
                      :value="one.school_id"
                    >
                      {{ one.school_name }}
                    </option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
          <!-- 連絡先（通知）メールアドレス -->
          <div v-bind:class="{ disable: !emailEnable }">
            <h3>連絡先（通知）メールアドレス</h3>
            <p class="lead1">
              「ツイタもん」システムからのメールを受信するアドレスをご入力ください。
            </p>
            <p class="lead1">
              メールが届かない場合は、<a
                href="https://tsuitamon.jp/nondelivery/"
                target="_blank"
                >受信許可の設定</a
              >または迷惑メールフォルダをご確認ください。
            </p>
            <ul>
              <li>
                <input
                  type="email"
                  id="noselect"
                  name="email"
                  placeholder="example@example.com"
                  autocomplete="on"
                  v-bind:tabindex="emailEnable ? '' : '-1'"
                  v-model="email"
                  @blur="updateInputError"
                />
              </li>
            </ul>
            <p class="lead2">
              ※hotmail／outlook／exciteなどのメールアドレスの場合、「ツイタもん」からのメールが正常に受信できない場合がございます。<br
                class="sp"
              />
              （gmail／yahooのアドレスは問題なく使用可能です。）
            </p>
          </div>
        </div>
        <p class="has_error">
          入力エラーがあります。お手数ですが、該当箇所を入力しなおしてください。
        </p>
        <div class="btn">
          <button type="submit" v-bind:disabled="!submitEnable">
            送信する
          </button>
        </div>
      </form>
    </main>

    <app-footer />

    <scroll-to-top />
    <loading-anim
      v-bind:show="isLoading"
      :loaderColor="AppConst.LOADING.COLOR"
      :boxColor="AppConst.LOADING.BOXCOLOR"
    />
  </div>
</template>

<script>
import Vue from "vue";
import IcheckMixin from "@mixins/icheck-mixin";
import ValidationMixin from "@mixins/validation-mixin";
import CmnSubMixin from "@mixins/cmnsub-mixin";
import HandleAjaxErrorMixin from "@mixins/handle-ajax-error-mixin";
import AppHeader from "@components/AppHeader";
import HeaderStep from "@components/HeaderStep";
import LoadingAnim from "@components/LoadingAnim";
import AppFooter from "@components/AppFooter";
import ScrollToTop from "@components/ScrollToTop";
import axios from "axios";
import AppConst from "@utils/app-const";
import $ from "jquery";

export default {
  name: "Index",
  mixins: [IcheckMixin, ValidationMixin, CmnSubMixin, HandleAjaxErrorMixin],
  components: { AppHeader, HeaderStep, LoadingAnim, AppFooter, ScrollToTop },
  data() {
    return {
      kw: "",
      schoolId: "",
      email: "",
      isLoading: false,
      schoolList: [], // 学校選択肢一覧
      hasInpError: false, // 入力エラーがあるか
    };
  },
  computed: {
    isKwEmpty: function () {
      return this.kw.length === 0;
    },
    /**
     * メールアドレス入力可
     */
    emailEnable: function () {
      return this.schoolId > 0;
    },
    /**
     * 送信ボタン活性
     */
    submitEnable: function () {
      // console.log("submitEnable", "-", this.schoolId, "-", this.email.length);
      return this.schoolId > 0 && this.email.length > 0;
    },
  },
  created() {},
  mounted() {
    // 入力チェック初期化
    this.initValidation();
    // CSRFトークン取得
    axios.get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF);
  },
  methods: {
    /**
     * 入力チェック初期化
     */
    initValidation: function () {
      var t = this;
      this.loadValidation().then(() => {
        /* フォーム入力チェック */
        $(t.$refs.fInp).validate({
          rules: {
            email: {
              required: true,
              email: true,
            },
            school_id: {
              required: true,
            },
          },
          messages: {
            email: {
              required: "※必須入力項目です。",
              email: "※メールアドレスは xxx@xxxx.xxxxx 形式で入力してください",
            },
            school_id: {
              required: "※必須入力項目です。",
            },
          },
          errorPlacement: function (error, element) {
            error.insertAfter(element);
          },
          focusInvalid: false,
          submitHandler: t.validHandler,
          invalidHandler: t.invalidHandler,
        });
      });
    },

    /**
     * 学校検索ボタン
     */
    searchSchool: function () {
      // const t = this;
      this.isLoading = true;
      axios
        .post(process.env.VUE_APP_API_BASE + AppConst.API.URL.SRCH_SCHOOL, {
          kw: this.kw,
        })
        .then((response) => {
          this.isLoading = false;
          var res = response.data;
          if (res.res_cd == AppConst.RET_CD.OK && res.data.length > 0) {
            // 学校プルダウン選択肢を設定して表示
            this.schoolList = res.data;
            this.schoolId = "";
            Vue.nextTick(() => {
              $(this.$refs.fInp).validate().resetForm();
            });
            $(".school_result").slideDown();
          } else {
            $(".school_result").slideUp();
            this.confirm({
              title: "",
              message: "該当する学校がありません。",
              buttons: {
                閉じる: {
                  color: "#000",
                  action: function () {
                    return false;
                  },
                },
              },
            });
          }
        })
        .catch((reason) => {
          // console.log(reason);
          // エラー
          this.isLoading = false;
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.confirm({
              title: "",
              message: "電波状態の良いところで<br/>再度おためしください。",
              buttons: {
                閉じる: {
                  color: "#000",
                  action: function () {
                    return false;
                  },
                },
              },
            });
          }
        });
    },
    /**
     * バリデーションOK
     */
    validHandler: function (/* form */) {
      // console.log("validHandler");
      $(".has_error").hide();
      var data = {
        school_id: this.schoolId,
        email: this.email,
      };
      this.isLoading = true;
      axios
        .post(
          process.env.VUE_APP_API_BASE + AppConst.API.URL.CONFIRM_EMAIL,
          data
        )
        .then((response) => {
          this.isLoading = false;
          let res = response.data;
          if (res.res_cd == AppConst.RET_CD.OK) {
            // 成功
            // 確認メール送信完了画面に遷移
            this.$router.push({
              name: AppConst.ROUTENM.SENT,
              params: {
                token: res.data.token,
              },
            });
          } else {
            this.alert(res.errmsg, "情報", "閉じる");
          }
        })
        .catch((reason) => {
          this.isLoading = false;
          // エラー
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.alert(
              "電波状態の良いところで<br/>再度おためしください。",
              "情報",
              "閉じる"
            );
          }
        });
    },
    /**
     * バリデーションNG
     */
    invalidHandler: function () {
      // console.log("invalidHandler");
      $(".has_error").show();
    },
    /**
     * 入力項目1個変更時、その項目のエラー有無表示を更新し、全体エラー有無表示状態を更新する
     * 全体エラーは、送信ボタンを押したときの入力チェックNGの時に表示し、
     * その後、エラー項目がなくなったら消す。
     */
    updateInputError: function (e) {
      // 対象項目1個のエラーチェック
      $(e.currentTarget).valid();
      Vue.nextTick(function () {
        // console.log($("input.error").length, "-", $("select.error").length);
        if ($("input.error").length === 0 && $("select.error").length === 0) {
          $(".has_error").hide();
        }
      });
    },
  },
};
</script>
